import CityLandingPage from './CityLandingPage';
import { cityPages } from '@/mocks/cityPages';

const data = cityPages.find((c) => c.slug === 'electronics-recycling-redondo-beach')!;

const RedondoBeachPage = () => <CityLandingPage data={data} />;

export default RedondoBeachPage;
